export const DIFFICULTY_LEVELS = ['BEGINNER', 'INTERMEDIATE', 'ADVANCED'];
export const DIFFICULTY_CONFIG = {
  BEGINNER: {
    title: 'learningCenter.interactiveEducation.quiz.difficulty.beginner',
    description: 'learningCenter.interactiveEducation.quiz.difficulty.beginnerDescription'
  },
  INTERMEDIATE: {
    title: 'learningCenter.interactiveEducation.quiz.difficulty.intermediate',
    description: 'learningCenter.interactiveEducation.quiz.difficulty.intermediateDescription'
  },
  ADVANCED: {
    title: 'learningCenter.interactiveEducation.quiz.difficulty.advanced',
    description: 'learningCenter.interactiveEducation.quiz.difficulty.advancedDescription'
  }
};